/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import StoryCard from "./StoryCard";
import Newsletter from "../../atoms/Newsletter";

import "./two-col-one-story-var-one.m.css";

export function TwoColumnOneStoryVarOne({ collection, stories, extraProp = "" }) {
  let {
    show_row_separator,
    show_read_time,
    show_row_title,
    show_timestamp,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_sub_headline,
    show_newsletter_dialog,
    show_row_ad_unit,
    row_ad_unit_details,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});
  const device = useDeviceType();
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  let adHeight = 250;
  if (device === "mobile") {
    show_newsletter_dialog = false;
    adHeight = 250;
  } else if (device === "tablet") {
    show_newsletter_dialog = false;
  } else if (device === "desktop" && show_newsletter_dialog) {
    adHeight = 250;
  } else if (!show_newsletter_dialog) {
    adHeight = 600;
  }
  const adstyle = "two-col-one-ad-slot-size-300x" + adHeight;

  const rowAd = row_ad_unit_details?.split("/").slice(-1)[0];
  const rowAdDivId = useSelector((state) => get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAd], ""));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const [firstStory] = stories;
  const sectionSlug = extraProp;

  if (!firstStory) return null;
  return (
    <>
      <div className="row-component" styleName="two-col-one-story-var-one">
        {show_row_title && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enable_sponsor_ad}
            sponsorAdDetails={sponsor_ad_details}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
        <div styleName="story-list">
          <div styleName="main-story">
            <StoryCard
              story={firstStory}
              showTimeStamp={show_timestamp}
              showReadTime={show_read_time}
              showSubHeadline={show_sub_headline}
              sectionSlug={sectionSlug}
            />
          </div>
          {show_row_ad_unit && (
            <div styleName="ad-container">
              <DfpComponent adStyleName={adstyle} id={rowAdDivId} />
              {show_newsletter_dialog && <Newsletter customStyle={{ width: "350px", marginTop: "16px" }} />}
            </div>
          )}
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </>
  );
}

TwoColumnOneStoryVarOne.propTypes = {
  config: PropTypes.object,
  collection: PropTypes.object.isRequired,
  stories: PropTypes.array.isRequired,
  extraProp: PropTypes.string,
};

TwoColumnOneStoryVarOne.storyLimit = 1;
